module.exports = __webpack_public_path__ + "img/m2g_about.3e901490.png";